// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7f73599c","353":"e6eda22d","545":"d74bd65f","787":"f8b0d36a","850":"ec67c80e"}[chunkId] + ".chunk.js";
};